export type WebhookTabValue = "overview" | "events" | "deliveries";

export const WEBHOOK_TABS: { value: WebhookTabValue; label: string }[] = [
	{ value: "overview", label: "Configuration" },
	{ value: "events", label: "Types d'évènements" },
	{ value: "deliveries", label: "Évènements envoyes" },
];

export const DELIVERIES_PAGE_SIZE = 25;
